import { fetchAll } from './fetch';
import News from 'models/news';
import Story from 'models/story';

export default fetchAll('parameter', { news: News, stories: Story });
